/**
 * An application utilities.
 *
 * @class Utils
 * @memberof Mojito.Applications.Common
 */

/**
 * Invokes a <code>renderer</code> function from a given descriptor and returns the result.
 * If no `renderer` is defined, it attempts to find one in the `renderersMap` using the descriptor's type.
 * If found, the `renderer` is executed. If not found, `null` is returned.
 *
 * @param {object} renderersMap - A map associating types to their corresponding rendering functions.
 * @param {object} descriptor - An object that describes the renderer.
 * @param {string} descriptor.type - The type of renderer to lookup in `renderersMap`.
 * @param {Function} descriptor.renderer - Renderer function to be called.
 * @param {React.ReactNode} parent - A reference to the caller component.
 *
 * @returns {*} A React element, or null if no suitable renderer is found.
 * @function Mojito.Applications.Common.Utils.renderOverlayItem
 */
export function renderOverlayItem(renderersMap, descriptor, parent) {
    const { type, renderer } = descriptor;
    const doRender = renderer || renderersMap[type];
    return doRender ? doRender(parent) : null;
}
